








































import { Vue, Component } from 'vue-property-decorator';
import {
  FmvDrawerLayout,
} from 'fmv-layout';
import {FmvAvatar} from 'fmv-avatar';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import { api } from '@/api';
import {IFooterLink} from '@/interfaces/pages';

@Component({
  components: {
    FmvDrawerLayout,
    FmvAvatar,
    MdIcon,
  },
})
export default class Footer extends Vue {
  public isDark = false;
  public footerClass = 'bg-white border-top-2';
  public footerBrand = 'unifordi';
  public footerLogo = '/';
  public containerClass = 'container page__container';
  /* tslint:disable */
  public copyrightYear = (new Date).getFullYear();
  public footerLinks: IFooterLink[] = [];

  public async mounted() {
    const response = await api.getFooterlinks(this.$store.getters.token);
    if (response) {
       this.footerLinks = response.data;
    }
  }

  public slotProps() {
    return {
      footerBrand: this.footerBrand,
      footerLogo: this.footerLogo,
      copyrightYear: this.copyrightYear,
    };
  }
}
